import { ISubscriptions } from '../types';
import { ISubscriptionAdminState } from '../../subscriptionAdmin/types';

export const getSubscriptions = (
    state: ISubscriptionAdminState
): ISubscriptions => {
    return state.subscriptions || {};
}
